import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TreeView from '@material-ui/lab/TreeView'
import { CustomTreeItem } from '@components/common'
import InsertChartIcon from '@material-ui/icons/InsertChart'
import DeleteIcon from '@material-ui/icons/Delete'
import FolderIcon from '@material-ui/icons/Folder'
import MapIcon from '@material-ui/icons/Map'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'
import FavoriteIcon from '@material-ui/icons/Favorite'
import SchoolIcon from '@material-ui/icons/School'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
    borderTopWidth: 20,
    borderColor: 'transparent',
    borderStyle: 'solid',
    overflowX: 'hidden'
  }
})

const CompsProjectsExplorer = ({
  getAllProjects,
  getRecentProjects,
  setPagination,
  setRecentPagination,
  searchProjects,
  regions,
  setTotalProjectsText,
  favoriteUserId,
  getMapProjects,
  setMapsPagination
}) => {
  const classes = useStyles()

  const getProjects = (type, region) => {
    switch (type) {
      case 'portfolios':
        setPagination({ 'queryParams': { isPortfolio: true }, offset: 0 })
        searchProjects({})
        setRecentPagination({ 'queryParams': { isPortfolio: true }, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: ' from Portfolios' })
        break
      case 'trash':
        setPagination({ 'queryParams': { isDeleted: true }, offset: 0 })
        searchProjects({})
        setRecentPagination({ 'queryParams': { isDeleted: true }, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: ' from Trash' })
        break
      case 'region':
        setPagination({ 'queryParams': { office: region.id }, offset: 0 })
        searchProjects({})
        setRecentPagination({ 'queryParams': { office: region.id }, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: ` from ${region.officeName}` })
        break
      case 'favorite':
        setPagination({ 'queryParams': { favoriteUserId }, offset: 0 })
        searchProjects({})
        setRecentPagination({ 'queryParams': { favoriteUserId }, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: ' from Favorite' })
        break
      case 'studentHousing':
        setPagination({ 'queryParams': { templateName: 'studentHousingComps' }, offset: 0 })
        searchProjects({})
        setRecentPagination({ 'queryParams': { templateName: 'studentHousingComps' }, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: ' from Student Housing' })
        break
      case 'maps':
        setMapsPagination({ offset: 0 })
        getMapProjects()
        break
      default:
        setPagination({ 'queryParams': {}, offset: 0 })
        getAllProjects()
        setRecentPagination({ 'queryParams': {}, offset: 0 })
        getRecentProjects()
        setTotalProjectsText({ totalProjectsText: '' })
    }
  }

  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      data-testid="CompsProjectsExplorer"
    >
      <div data-testid="all-projects-folder-item" id="all-projects" onClick={() => getProjects('allProjects')}>
        <CustomTreeItem nodeId="1" labelText="All Projects" labelIcon={InsertChartIcon} />
      </div>
      <div data-testid="portfolio-folder-item" id="portfolios" onClick={() => getProjects('portfolios')}>
        <CustomTreeItem nodeId="2" labelText="Portfolios" labelIcon={BusinessCenterIcon} />
      </div>
      <div data-testid="favorite-folder-item" id="favorite" onClick={() => getProjects('favorite')}>
        <CustomTreeItem nodeId="3" labelText="Favorite" labelIcon={FavoriteIcon} />
      </div>
      <div data-testid="studenthousing-folder-item" id="student-housing" onClick={() => getProjects('studentHousing')}>
        <CustomTreeItem nodeId="6" labelText="Student Housing" labelIcon={SchoolIcon} />
      </div>
      <CustomTreeItem nodeId="4" labelText="Regions" labelIcon={FolderIcon}>
        {regions &&
          regions.map((region, index) => (
            <div key={index} id={region.officeName} onClick={() => getProjects('region', region)} data-testid={`region-folder-item${index}`}>
              <CustomTreeItem
                nodeId={`7+${index}`}
                labelText={region.officeName}
                labelIcon={LocationOnIcon}
              />
            </div>
          ))
        }
      </CustomTreeItem>
      <div data-testid="trash-folder-item" onClick={() => getProjects('trash')}>
        <CustomTreeItem nodeId="5" labelText="Trash" labelIcon={DeleteIcon} />
      </div>
      <div data-testid="maps-folder-item" onClick={() => getProjects('maps')}>
        <CustomTreeItem nodeId="8" labelText="Maps" labelIcon={MapIcon} />
      </div>
    </TreeView>
  )
}

CompsProjectsExplorer.propTypes = {
  getAllProjects: PropTypes.func,
  getRecentProjects: PropTypes.func,
  setPagination: PropTypes.func,
  setRecentPagination: PropTypes.func,
  searchProjects: PropTypes.func,
  regions: PropTypes.array,
  setTotalProjectsText: PropTypes.func,
  favoriteUserId: PropTypes.string,
  getMapProjects: PropTypes.func,
  setMapsPagination: PropTypes.func
}

export default CompsProjectsExplorer
